import { GeneralProduct, GeneralProductProps } from '../components/GeneralProduct';
import { useShippingGeneralProductService } from '../services/useShippingGeneralProductService';

export const ShippingGeneralProductContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const props: GeneralProductProps = useShippingGeneralProductService();

  if (!props.estimated_shipping_date && !props.shipping_send_date) {
    return null;
  }

  return <GeneralProduct {...props} />;
};
